import React from 'react'

import { ButtonClean, PriceString } from '@fourthwall/components'

import { formatDate, isSameDay } from '../../../utils/date'
import * as S from './OrderTimelineEvent.styled'
import type { Props } from './types'

export const OrderTimelineEvent = ({ timelineEvent, timelineFulfillment }: Props) => {
  if (timelineEvent?.eventType.type === 'ORDER_PAID') {
    return (
      <S.Container>
        Order placed for <PriceString value={timelineEvent.eventType.money?.value} />
      </S.Container>
    )
  }
  if (timelineEvent?.eventType.type === 'SHIPPING_LABEL_CREATED') {
    const { shippingLabelCarrier, shippingLabelTrackingCode, trackerUrl } =
      timelineEvent.eventType.shipmentTracker

    return (
      <S.Container>
        Shipping label created for {shippingLabelCarrier} ({shippingLabelTrackingCode}){' '}
        {trackerUrl && <ButtonClean href={trackerUrl} target="_blank" label="[Track Package]" />}
      </S.Container>
    )
  }
  if (timelineEvent?.eventType.type === 'SHIPMENT_SHIPPED') {
    const { shippingLabelCarrier, shippingLabelTrackingCode, trackerUrl } =
      timelineEvent.eventType.shipmentTracker

    return (
      <S.Container>
        Package shipped with {shippingLabelCarrier} ({shippingLabelTrackingCode}){' '}
        {trackerUrl && <ButtonClean href={trackerUrl} target="_blank" label="[Track Package]" />}
      </S.Container>
    )
  }
  if (timelineEvent?.eventType.type === 'SHIPMENT_DELIVERED') {
    const { shippingLabelTrackingCode } = timelineEvent.eventType.shipmentTracker

    return <S.Container>Package ({shippingLabelTrackingCode}) was delivered</S.Container>
  }

  if (timelineFulfillment?.shipments[0]?.deliveryEstimate) {
    const from = timelineFulfillment.shipments[0].deliveryEstimate.from
    const to = timelineFulfillment.shipments[0].deliveryEstimate.to

    const dateString = isSameDay(from, to)
      ? `on ${formatDate(from, 'dddd, MMM D')}`
      : `between ${formatDate(from, 'dddd, MMM D')} and ${formatDate(to, 'dddd, MMM D')}`

    return <S.Container>Estimated delivery {dateString}</S.Container>
  }

  return <S.Container>{timelineEvent?.description}</S.Container>
}
